import { mutatorAction } from 'satcheljs';
import { ConfettiOptions } from 'owa-outlook-service-options';

export default mutatorAction(
    'updateUserConfettiOption',
    (userOptions: ConfettiOptions, confettiEnabled: boolean) => {
        userOptions.confettiEnabled = confettiEnabled;
    }
);
